import React from 'react';
import { Box, Container, Paper, Stack, Button, Typography } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

function ExerciseNavigation({ 
  sectionExamples, 
  sectionIndex, 
  onPrevious, 
  onNext 
}) {
  if (sectionExamples.length === 0) return null;

  return (
    <Box sx={{ flexShrink: 0, borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Container maxWidth="xl">
        <Paper elevation={0} sx={{ p: 1.5 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Button
              startIcon={<ArrowBackIos />}
              onClick={onPrevious}
              disabled={sectionIndex === 0}
              variant="outlined"
              size="small"
            >
              上一题
            </Button>
            <Typography variant="body2" color="text.secondary">
              第 {sectionIndex + 1} / {sectionExamples.length} 题
            </Typography>
            <Button
              endIcon={<ArrowForwardIos />}
              onClick={onNext}
              disabled={sectionIndex === sectionExamples.length - 1}
              variant="outlined"
              size="small"
            >
              下一题
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}

export default ExerciseNavigation;

